interface AlbumUserDetailParams {}

export const getNewAlbumUserDetailParams = () => {
  return {};
};

export default AlbumUserDetailParams;
